import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledCardOwner = styled(Text)`
	position: absolute;
	right: 60px;
	top: 50%;
	transform: translateY(-50%);
	font-weight: 500;
	font-size: 16px;
	color: #ffffff;
	transition: color 0.3s ease;
	pointer-events: none;

	span {
		font-weight: 400;
		opacity: 0.5;
	}
`;

const StyledCardOwnerError = styled(Text)`
	position: absolute;
	right: 60px;
	top: 50%;
	transform: translateY(-50%);
	font-size: 16px;
	color: #ffffff;
	opacity: 0.5;
	pointer-events: none;
	transition: color 0.3s ease;
`;

const StyledContainer = styled.div`
	position: relative;

	img {
		position: absolute;
		right: 20px;
		top: 50%;
		transform: translateY(-50%);
		width: 20px;
		height: 20px;
		opacity: 0.5;
		user-select: none;
		pointer-events: none;
		transition:
			opacity 0.3s ease,
			filter 0.3s ease;
	}

	&:hover {
		img {
			opacity: 1;
			filter: invert(1);
		}

		${StyledCardOwner}, ${StyledCardOwnerError} {
			color: #000000;
		}
	}
`;

export { StyledCardOwner, StyledCardOwnerError, StyledContainer };
